import { FormGroup, Row, Col, FormFeedback } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import SelectField from "../Utils/SelectField";
import "react-phone-number-input/style.css";
import {
  handleChangeForCity,
  handleChangeForCountry,
  handleChangeForImsi,
  handleChangeForLimit,
  handleChangeForName,
  handleChangeForState,
} from "./constants/HandleChangeFunctions";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useState } from "react";
import {
  dialCodeFocusChange,
  validatePhoneNumber,
} from "./constants/DocumentTableFunctions";
import { CreatableSelectField } from "../Utils/CreatableSelectField";
import {
  handleFileChange,
  removeProfilePicture,
} from "./constants/constantFunctions";

export default function LimitOverride({
  values,
  touched,
  errors,
  setFieldValue,
  handleBlur,
  isFromSubscriptionModal
  
}) {
  return (
    <>
      <Row className="pe-2"> 
        <Col lg={isFromSubscriptionModal?4:undefined} xxl={isFromSubscriptionModal?undefined:3} md={6} className="pe-0">
          <div>
            <FormGroup>
              <LabelText
                htmlFor={"ceiling"}
                classLabelName={"ms-0 rv-form-label"}
                className={"text-danger"}
                displayText={"Ceiling"}
              />
              <LabelText
                htmlFor={"ceiling"}
                displayText={
                  touched.ceiling && errors.ceiling
                    ? errors.ceiling
                    : "Enter Ceiling"
                }
                classLabelName={`d-block ms-0 rv-sub-label ${
                  touched.ceiling && errors.ceiling
                    ? "rv-label-danger"
                    : "rv-label-muted"
                } `}
              />
              <InputField
                name={"ceiling"}
                // placeholder={"Enter Ceiling"}
                type={"text"}
                className={"form-control"}
                id={"ceiling"}
                handleChange={handleChangeForLimit(setFieldValue, "ceiling")}
                handleBlur={handleBlur}
                value={values.ceiling}
                invalid={touched.ceiling && errors.ceiling ? true : false}
              />
              {/* {touched.ceiling && errors.ceiling ? (
                <FormFeedback type="invalid">{errors.ceiling}</FormFeedback>
              ) : null} */}
            </FormGroup>
          </div>
        </Col>
        <Col lg={isFromSubscriptionModal?4:undefined} xxl={isFromSubscriptionModal?undefined:3} md={6} className="pe-0">
          <div>
            <FormGroup>
              <LabelText
                htmlFor={"floor"}
                classLabelName={"ms-0 rv-form-label"}
                className={"text-danger"}
                displayText={"Floor"}
              />
              <LabelText
                htmlFor={"floor"}
                displayText={
                  touched.floor && errors.floor ? errors.floor : "Enter Floor"
                }
                classLabelName={`d-block ms-0 rv-sub-label ${
                  touched.floor && errors.floor
                    ? "rv-label-danger"
                    : "rv-label-muted"
                } `}
              />
              <InputField
                name={"floor"}
                // placeholder={"Enter Floor"}
                type={"text"}
                className={"form-control"}
                id={"floor"}
                handleChange={handleChangeForLimit(setFieldValue, "floor")}
                handleBlur={handleBlur}
                value={values.floor}
                invalid={touched.floor && errors.floor ? true : false}
              />
              {/* {touched.floor && errors.floor ? (
                <FormFeedback type="invalid">{errors.floor}</FormFeedback>
              ) : null} */}
            </FormGroup>
          </div>
        </Col>
      </Row>
    </>
  );
}
